export class NetzzuordnungIdImportJob {

    public report?: string;
    public finished: Date;
    public rowsTotal: number = 1;
    public nrStoredNetzzuordnungIds: number = 0;
    public filename: string;
    public phase: NetzzuordnungIdImportJobPhase;
    public error: boolean;
}

export enum NetzzuordnungIdImportJobPhase {
    PHASE_INITIAL = 10,
    PHASE_PRE_VALIDATE = 20,
    PHASE_VALIDATED = 30,
    PHASE_PERSIST = 40,
    PHASE_FINALIZE = 50
}
